import { createApiRequest } from "@/lib/api/createApiService";
import { ACTIVITY_LOG_ENDPOINTS } from "./activity-log.endpoints";

export const activityLogService = {
  listLogs: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ACTIVITY_LOG_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  listUsers: async (options = {}) => {
    return createApiRequest({
      url: ACTIVITY_LOG_ENDPOINTS.USERS,
      method: "GET",
      ...options,
    });
  },
};
